import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mutateImageUrl } from '../../wordpress';

/**
 * Navigation item component
 *
 * Defines the basic "Hats & hair", "Heads" etc. navigation items that will
 * display the selected item if available
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Minifigs
 */

const NavigationItem = ({ id, title, selected, isActive, categoryInfo, displayProducts, torsoOverlays, loading }) => {
    const classes = classNames('navigation-item', id, {
        'navigation-item-active': isActive,
        'navigation-item-hasproduct': selected !== null,
        'navigation-item-loading': loading,
    });

    if (!selected) {
        return (
            <li role="button">
                <button
                    onClick={() => {
                        if (!loading) {
                            displayProducts(categoryInfo);

                            const builderNav = document.querySelector('.navigation__project_switcher--wrapper');
                            builderNav.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }}
                    className={classes}
                >
                    <h3>{title}</h3>
                </button>
            </li>
        );
    }

    let imgSrc = '';
    if (selected.attributes && selected.attributes?.image?.url) {
        imgSrc = mutateImageUrl(selected.attributes.image.url, 480, 480);
    } else if (selected.productMatchAttr?.image?.url) {
        imgSrc = selected.productMatchAttr.image.url;
    } else if (selected?.product?.featuredImage?.url) {
        imgSrc = selected.product.featuredImage.url;
    }

    let selectedProdTitle = '';
    if (selected.category.id === 'heads') {
        selectedProdTitle = selected.productMatchAttr?.image?.url;
    } else {
        selectedProdTitle = selected.product.title.split('-')[0];
    }

    let selectedVariant =
        selected.productMatchAttr !== null && selected.productMatchAttr !== undefined ? (
            selected.productMatchAttr.option1 !== 'Default Title' ? (
                <span> - {selected.productMatchAttr.option1}</span>
            ) : null
        ) : null;

    let customised;
    //     if (selected.productMatchAttr !== null && selected.productMatchAttr !== undefined) {
    //         if (propCost !== null || selected.product.variants.length > 1) {
    //             customised = true;
    //         }
    //     }
    // }

    return (
        <li
            role="button"
            onClick={() => {
                if (!loading) {
                    displayProducts(categoryInfo);
                }
            }}
            className={classes}
        >
            <h3>{title}</h3>

            <div className="vh">
                {selectedProdTitle}
                {selectedVariant}
            </div>

            <img className="navigation-item__image" src={imgSrc} alt="" />

            {categoryInfo.id === 'bodies' && (
                <>
                    {torsoOverlays && (
                        <>
                            <img
                                className="preview-item__image overlay handImage"
                                src={torsoOverlays.handImage}
                                alt=""
                            />
                            <img
                                className="preview-item__image overlay torsoOverlayImage"
                                src={torsoOverlays.torsoOverlayImage}
                                alt=""
                            />
                        </>
                    )}
                </>
            )}

            {customised ? <span className="navigation-customised">Customised</span> : null}
        </li>
    );
};

NavigationItem.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    emptyText: PropTypes.string,
    selected: PropTypes.object,
    isActive: PropTypes.bool,
    onSelect: PropTypes.func,
    categoryInfo: {
        id: PropTypes.string,
    },
    torsoOverlays: {
        handImage: PropTypes.string,
        torsoOverlayImage: PropTypes.string,
    },
    displayProducts: PropTypes.func,
    loading: PropTypes.bool,
};

NavigationItem.defaultProps = {
    emptyText: 'No selection',
    selected: null,
    isActive: false,
    onSelect: () => {},
};

export default NavigationItem;
